import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { submitLogin, resetLoginData } from "../../redux/action/login";
import { generateOTPCall, verifyOTPCall, submitBasicInfo, resetSignUpData } from "../../redux/action/signup";
import { showPopup } from "../../redux/action/common";
import { Link, useNavigate } from "react-router-dom";
import SachImage from "../../static/user/img/sach-icon.svg";
import SachLoader from "../Loader";
import { checkAuthentication, checkValidUsername, parseHtml } from "../../utils/util";
import SignUpPage from "../SignUpPage";
import "./style.css";
import { getLoginDataAPI, getSignUpDataAPI } from "../../redux/action/common-action";
import ForgotModal from "./forgotModal";
import SuccessfullModal from "./Successfull";
import { UserRoutes } from "../../routes";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Login = (props) => {
  const { onLoginSubmit, loginDetails, allowSignUp = true, commonData, showPopup, resetLoginData, getLoginDataAPI, loginJsonData } = props;
  let navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [isUserEmpty, setIsUserEmpty] = useState(false);
  const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
  const [password, setPassword] = useState("");
  const [isUsernameValid, setValidUsername] = useState(true);
  const [showPass, setShowPass] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [forgotModal, setForgotModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  useEffect(() => {
    if (checkAuthentication()) {
      navigate(UserRoutes.USER_ROOT);
      return;
    }
    resetLoginData();
    getLoginDataAPI();
    getSignUpDataAPI();
  }, []);

  const toggleHover = () => setHovered(!hovered);

  const onUsernameChange = (user) => {
    if (user !== "") {
      // if (user != "" && checkValidUsername(user)) {
      setValidUsername(true);
      setIsUserEmpty(false);
    } else {
      setValidUsername(false);
    }
    if (loginDetails.isLoginFailed) {
      resetLoginData();
    }
    setUsername(user);
  };

  const handleKeyDown = (event) => {
    if (event.key == "Enter") {
      onClickLogin();
    }
  };
  const onPasswordChange = (password) => {
    if (password != "") {
      setIsPasswordEmpty(false);
    }
    if (loginDetails.isLoginFailed) {
      resetLoginData();
    }
    setPassword(password);
  };

  const onClickLogin = () => {
    let redirectUrl = null;
    var index = window.location.href.indexOf("redirect=");
    if (index !== -1) redirectUrl = window.location.href.split("redirect=")[1];

    if (isUsernameValid && username !== "" && password !== "" && !loginDetails.isLoginFailed) {
      onLoginSubmit({ userId: username, password, redirectUrl: redirectUrl }, navigate);
      // setUsername("");
      // setPassword("");
    }
    if (username === "") setIsUserEmpty(true);
    if (password === "") setIsPasswordEmpty(true);
    return;
  };

  const onClickSignUp = () => {
    showPopup("signUp", {});
    // navigate("/signup");
  };
  const renderSignUpPopup = (data) => {
    return (
      <Modal className="signUp-modal" centered visible={true} closable={false} onCancel={() => showPopup(null)} footer={null}>
        <SignUpPage {...props} />
      </Modal>
    );
  };
  if (loginDetails?.isLoading) {
    return <SachLoader />;
  }

  const carouselSection = loginJsonData && loginJsonData.login && loginJsonData.login.carouselSection;
  const loginContent = loginJsonData && loginJsonData.login && loginJsonData.login.loginContent;
  const forgotPassword = loginJsonData && loginJsonData.forgotPassword;

  const handleForgot = () => {
    console.log("handleForgot - Before ", forgotModal, successModal);
    setForgotModal(true);
    setSuccessModal(false);
    console.log("handleForgot - After ", forgotModal, successModal);
  };

  const handleSuccess = () => {
    console.log("handleSuccess - Before ", forgotModal, successModal);
    setForgotModal(false);
    setSuccessModal(true);
    console.log("handleSuccess - After ", forgotModal, successModal);
  };

  return (
    <div>
      <div className="login-container login-modal">
        <Link className="modal-close" to={UserRoutes.USER_ROOT}>
          <i className="bi bi-x"></i>
        </Link>
        <div className="row h-100">
          <div className="col-lg-4 col-md-4 d-none d-md-block">
            <Swiper slidesPerView={1} spaceBetween={24} autoplay={true} centeredSlides={false} modules={[Autoplay, Pagination]} grabCursor={true} loop={true} pagination={{ clickable: true }} id="loginSlides">
              <SwiperSlide>
                <div className="login-bannr">
                  <img src={require("../../static/user/img/logo.svg").default} alt="Sach Foundation" className="login-logo" />
                  <img src={require("../../static/user/img/login-img-1.svg").default} alt="login-img-1" className="img-fluid px-4" />
                  <h2>Get Hope, Happiness, Health, and Aspiration in life</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="login-bannr dsc">
                  <img src={require("../../static/user/img/logo-white.svg").default} alt="Sac0h Foundation" className="login-logo" />
                  <img src={require("../../static/user/img/login-img-2.svg").default} alt="login-img-1" className="img-fluid px-4" />
                  <h2 className="text-white">1:1 Ask Question with Dr.Subhash Chandra</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="login-bannr">
                  <img src={require("../../static/user/img/logo.svg").default} alt="Sach Foundation" className="login-logo" />
                  <img src={require("../../static/user/img/login-img-3.svg").default} alt="login-img-1" className="img-fluid px-4" />
                  <h2>Choose Categories Based On Your Issues</h2>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="col-lg-8 col-md-8">
            <form className="row h-100 align-items-center">
              <div className="col-lg-5 col-md-5 mx-auto">
                <h1 className="title">{loginContent && parseHtml(loginContent.title)}</h1>
                <p className="para">{loginContent && parseHtml(loginContent.subTitle)}</p>
                <div className="col-12 sach-form">
                  <label className="form-label">{loginContent && loginContent.field1 && loginContent.field1.text}</label>
                  <input type="text" onKeyUp={(e) => (e.target.value = e.target.value.toUpperCase())} maxLength={10} className={`form-control text-uppercase ${loginDetails?.isLoginFailed || isUserEmpty ? "invalid" : ""} ${isUsernameValid ? "" : "invalid"}`} id="userID" value={username} onChange={(event) => onUsernameChange(event.target.value)} required />
                  {!isUsernameValid && <div className="col-12 mt-1 error-msg">{loginContent && loginContent.field1 && loginContent.field1.errorMsg}</div>}
                </div>

                <div className="col-12 sach-form">
                  <label className="form-label">{loginContent && loginContent.field2 && loginContent.field2.text}</label>
                  <div className="pass-wrapper">
                    <input type={showPass ? "text" : "password"} className={`form-control pe-5 ${loginDetails?.isLoginFailed || isPasswordEmpty ? "invalid" : ""}`} id="password" value={password} onChange={(event) => onPasswordChange(event.target.value)} onKeyDown={(event) => handleKeyDown(event)} maxLength={30} required />
                    <i onClick={() => setShowPass(!showPass)} className={showPass ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                  </div>
                </div>
                <p className="details text-end my-2">
                  <a onClick={(e) => handleForgot()}>{forgotPassword && forgotPassword.title}</a>
                </p>
                <div className="col-12 mt-4">
                  <button type="submit" className={`btn-sach login-btn ${hovered ? "btn-hover" : "bg-sach-dark"}`} onMouseEnter={toggleHover} onMouseLeave={toggleHover} onClick={onClickLogin}>
                    {loginContent && loginContent.cta && loginContent.cta.text}
                  </button>
                </div>
                {loginDetails?.isLoginFailed && <div className="col-12 mt-1 error-msg">{loginDetails?.loginData?.message || "Invalid username or password"}</div>}
                {/* <div className="col-12 mt-3 text-center">
                  <span>or</span>
                </div>
                <div className="col-12 mt-3">
                  <button className="social-login-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M5.81891 14.5066L4.9835 17.6252L1.93011 17.6898C1.01759 15.9973 0.5 14.0609 0.5 12.0031C0.5 10.0132 0.983938 8.13667 1.84175 6.48438H1.84241L4.56078 6.98275L5.75159 9.68481C5.50236 10.4114 5.36652 11.1914 5.36652 12.0031C5.36661 12.8839 5.52617 13.7279 5.81891 14.5066Z" fill="#FBBB00" />
                      <path d="M24.2902 9.75781C24.428 10.4837 24.4999 11.2334 24.4999 11.9996C24.4999 12.8587 24.4095 13.6967 24.2375 14.5051C23.6533 17.2558 22.1269 19.6578 20.0124 21.3576L20.0118 21.3569L16.5878 21.1822L16.1032 18.1572C17.5063 17.3343 18.6028 16.0466 19.1804 14.5051H12.7637V9.75781H19.274H24.2902Z" fill="#518EF8" />
                      <path d="M20.0114 21.3538L20.0121 21.3545C17.9556 23.0074 15.3433 23.9965 12.4996 23.9965C7.92969 23.9965 3.95652 21.4422 1.92969 17.6833L5.81848 14.5C6.83187 17.2046 9.44089 19.1299 12.4996 19.1299C13.8143 19.1299 15.046 18.7745 16.1029 18.154L20.0114 21.3538Z" fill="#28B446" />
                      <path d="M20.1596 2.76262L16.2721 5.94525C15.1783 5.26153 13.8853 4.86656 12.5 4.86656C9.37213 4.86656 6.71431 6.88017 5.75169 9.68175L1.84245 6.48131H1.8418C3.83895 2.63077 7.86223 0 12.5 0C15.4117 0 18.0814 1.03716 20.1596 2.76262Z" fill="#F14336" />
                    </svg>
                    <span>Continue with Google</span>
                  </button>
                </div>
                <div className="col-12 mt-3">
                  <button className="social-login-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none">
                      <path d="M12 0H9C6.23858 0 4 2.23858 4 5V7H0V11H4V18H8V11H12V7H8V5C8 4.44772 8.44771 4 9 4H12V0Z" fill="#067CEF" />
                    </svg>
                    <span>Continue with Facebook</span>
                  </button>
                </div> */}
                {allowSignUp && (
                  <p className="details">
                    {loginContent && loginContent.createAccount && loginContent.createAccount.text} <span onClick={onClickSignUp}>{loginContent && loginContent.createAccount && loginContent.createAccount.subTitle}</span>
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {successModal && (
        <SuccessfullModal
          handleCancel={() => {
            setSuccessModal(false);
            window.location.reload();
          }}
          forgotPassword={forgotPassword}
        />
      )}
      {forgotModal && <ForgotModal handleCancel={() => setForgotModal(false)} handleSuccess={handleSuccess} forgotPassword={forgotPassword} />}
      {commonData?.popupType != "" && commonData?.popupType === "signUp" && renderSignUpPopup(commonData?.popupData)}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { CommonReducer, LoginReducer } = state;
  return {
    ...state,
    loginDetails: state?.LoginReducer,
    commonData: state?.CommonReducer,
    signUpData: state?.SignUpReducer,
    loginJsonData: CommonReducer.loginJsonData,
    signUpJsonData: CommonReducer.signUpJsonData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoginSubmit: (data, navigate) => dispatch(submitLogin(data, navigate)),
    showPopup: (type, data) => dispatch(showPopup(type, data)),
    generateOTPCall: (data) => dispatch(generateOTPCall(data)),
    verifyOTPCall: (data) => dispatch(verifyOTPCall(data)),
    submitBasicInfo: (data, navigate, pathname) => dispatch(submitBasicInfo(data, navigate, pathname)),
    resetSignUpData: () => dispatch(resetSignUpData()),
    resetLoginData: () => dispatch(resetLoginData()),
    getLoginDataAPI: () => dispatch(getLoginDataAPI()),
    getSignUpDataAPI: () => dispatch(getSignUpDataAPI()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
